<template>
  <div class="content">
    <div class="bodycontent">
      <div class="phone-con">
        <SidePhone
          :title="ruleForm.title"
          :store="ruleForm.brand_name"
          :logoUrl="ruleForm.logo_url"
          :nowCardBg="nowCardBg"
        ></SidePhone>
      </div>
      <div class="card-set">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="会员卡标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="商铺名称" prop="brand_name">
            <el-input :disabled="!page_status" v-model="ruleForm.brand_name"></el-input>
          </el-form-item>
          <el-form-item label="客服电话" prop="service_phone">
            <el-input v-model="ruleForm.service_phone"></el-input>
          </el-form-item>
          <el-form-item label="logo" prop="logo_url">
            <el-upload
              class="avatar-uploader"
              action
              :show-file-list="false"
              :http-request="uploadLogo"
            >
              <img v-if="ruleForm.logo_url" :src="ruleForm.logo_url" class="avatar" />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                v-loading.fullscreen.lock="fullscreenLoading"
              ></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="背景色" prop="type">
            <el-radio-group v-model="ruleForm.type">
              <el-radio label="颜色" name="1"></el-radio>
              <el-radio label="背景图" name="2"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="type">
            <div class="color-con" v-if="ruleForm.type == '颜色'">
              <div
                class="color-item"
                @click="setColor(item)"
                v-for="(item, idx) in colorArr"
                :key="idx"
                :style="'background:' + item.value "
              ></div>
            </div>
            <el-upload
              v-else
              class="avatar-uploader"
              action
              :show-file-list="false"
              :http-request="uploadSectionFile"
            >
              <img v-if="background_pic_url" :src="background_pic_url" class="avatar" />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                v-loading.fullscreen.lock="fullscreenLoading"
              ></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否开启" prop="open">
            <el-switch v-model="ruleForm.open"></el-switch>
          </el-form-item>
          <el-form-item label="使用提醒" prop="notice" :max="16">
            <el-input type="textarea" v-model="ruleForm.notice"></el-input>
          </el-form-item>
          <el-form-item label="使用说明" prop="description">
            <el-input type="textarea" v-model="ruleForm.description"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="page_status" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button v-else type="primary" @click="submitForm('ruleForm')">立即修改</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--添加 手机号、姓名、性别、生日、地址、车牌号-->
      <div class="card-set" v-if="page_status">
        <el-table :data="payArr" style="width: 100%" :header-cell-style="setHeader">
          <el-table-column prop="title" label="信息"></el-table-column>
          <el-table-column prop="checked" label="启用">
            <template slot-scope="scope">
              <el-checkbox
                @change="setOptional(scope.row)"
                :disabled="scope.row.name == 'mobile'"
                :checked="scope.row.name == 'mobile'"
                v-model="scope.row.checked"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="required" label="必填">
            <template slot-scope="scope">
              <el-checkbox
                @change="setRequiredl(scope.row)"
                :disabled="scope.row.name == 'mobile'"
                :checked="scope.row.name == 'mobile'"
                v-model="scope.row.required"
              ></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--修改-->
      <div class="card-set" v-else>
        <el-table :data="payArr" style="width: 100%" :header-cell-style="setHeader">
          <el-table-column prop="title" label="信息"></el-table-column>
          <el-table-column prop="checked" label="启用">
            <template slot-scope="scope">
              <el-checkbox @change="setOptional(scope.row)" :checked="scope.row.checked ? true:false" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="required" label="必填">
            <template slot-scope="scope">
              <el-checkbox @change="setRequiredl(scope.row)" :checked="scope.row.required ? true:false" v-model="scope.row.required"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getColor,
  getCardList,
  editWxCard,
  getWxCardDetail,
  getWxEditCard
} from "@/api/vip";
import { CreateMiniCard } from "@/api/configuration"
import { upWxCardImage } from "@/api/common";
import { mapGetters } from "vuex";
import SidePhone from "./vipCard";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    SidePhone
  },
  watch: {
    "ruleForm.type": function(val) {
      if (val == "颜色") {
        this.nowCardBg = `background:${this.bgColor}`;
      } else {
        this.nowCardBg = `background:url(${this.background_pic_url})`;
      }
    },
    bgColor: function(val) {
      this.nowCardBg = `background:${val}`;
    },
    background_pic_url: function(val) {
      this.nowCardBg = `background:url(${val})`;
    }
  },
  data() {
    return {
      page_status: true, // 添加/编辑
      imageUrl: "",
      bgColor: "#f1f1f1",
      fullscreenLoading: false,
      background_pic_url: "",
      nowCardBg: "background:#f1f1f1",
      colorArr: [],
      ruleForm: {
        title: "",
        brand_name: "",
        service_phone: "",
        notice: "",
        color: "",
        description: "",
        type: "颜色",
        logo_url: "",
        open: true
      },
      cardInfo: {}, // 详情信息
      payArr: [],
      requiredArr: ["mobile"],
      optionsArr: ["mobile"],
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      rules: {
        logo_url: [{ required: true }],
        title: [
          { required: true, message: "请输入会员卡标题", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 9 个字符", trigger: "blur" }
        ],
        brand_name: [
          { required: true, message: "请输入商铺名称", trigger: "submit" },
          { min: 3, max: 12, message: "长度在 3 到 12 个字符", trigger: "blur" }
        ],
        notice: [
          { required: true, message: "请填写提醒内容", trigger: "submit" },
          {
            min: 3,
            max: 16,
            message: "长度在 3 到 16 个字符",
            trigger: "submit"
          }
        ],
        description: [
          { required: true, message: "请填写使用说明", trigger: "submit" }
        ],
        service_phone: [
          { required: true, message: "请填写客服手机号码", trigger: "submit" }
        ]
      }
    };
  },
  created() {
    this.getCardColor();
  },
  methods: {
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    // 获取微信修改字段
    getWxCon(id, req, opt) {
      getWxEditCard({
        token: this.token,
        app_id: this.app_id,
        card_id: id,
        required_form: req,
        optional_form: opt 
      }).then(res => {
        console.log(res);
      });
    },
    // 卡券颜色(修改、添加入口)
    getCardColor(color) {
      getColor({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.colorArr = res.data;
          if (this.$route.query.id) {
            // 修改
            this.page_status = false;
            this.requiredArr = [];
            this.optionsArr = [];
            this.getDetail(this.$route.query.id);
          } else {
            // 创建
            this.page_status = true;
            this.getOpenCardList();
          }
        }
      });
    },
    setOptional(item) {
      if (item.checked == 1) {
        this.optionsArr.push(item.name);
      } else {
        for (let i in this.optionsArr) {
          this.optionsArr[i] == item.name;
          this.optionsArr.splice(i, 1);
        }
      }
    },
    setRequiredl(item) {
      if (item.required == 1) {
        this.requiredArr.push(item.name);
        console.log(item.name);
      } else {
        for (let i in this.requiredArr) {
          this.requiredArr[i] == item.name;
          this.requiredArr.splice(i, 1);
        }
      }
    },
    // 背景上传图片
    uploadSectionFile(content) {
      this.fullscreenLoading = true;
      let data = new FormData();
      data.append("app_id", this.app_id);
      data.append("token", this.token);
      data.append("image", content.file);
      upWxCardImage(data).then(res => {
        this.fullscreenLoading = false;
        this.background_pic_url = res.data.url;
      });
    },
    // 开卡字段列表
    getOpenCardList() {
      let data = { token: this.token, app_id: this.app_id };
      getCardList(data).then(res => {
        if (res.code == 200) {
          this.payArr = res.data;
        }
      });
    },
    // 卡券详情
    getDetail() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        card_id: this.$route.query.id
      };
      getWxCardDetail(data).then(res => {
        if (res.code == 200) {
          // 表单赋值
          this.ruleForm = Object.assign({}, res.data);
          this.ruleForm.open = res.data.open ? true : false;
          this.payArr = res.data.open_field;
          for (let i in res.data.open_field) {
            if (res.data.open_field[i].checked == 1) {
              this.optionsArr.push(res.data.open_field[i].name)
            }
            if (res.data.open_field[i].required == 1) {
              this.requiredArr.push(res.data.open_field[i].name)
            }
          }
          if (res.data.background_pic_url == "") {
            this.ruleForm.type = "颜色";
            for (let i in this.colorArr) {
              if (this.colorArr[i].name == res.data.color) {
                this.bgColor = this.colorArr[i].value;
                return;
              }
            }
          } else {
            this.ruleForm.type = "背景图";
            this.background_pic_url = res.data.background_pic_url;
          }
        }
      });
    },
    uploadLogo(content) {
      this.fullscreenLoading = true;
      let data = new FormData();
      data.append("app_id", this.app_id);
      data.append("token", this.token);
      data.append("image", content.file);
      upWxCardImage(data).then(res => {
        this.fullscreenLoading = false;
        this.ruleForm.logo_url = res.data.url;
      });
    },
    setColor(item) {
      this.bgColor = item.value;
      this.ruleForm.color = item.name;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var data = this.ruleForm;
          data.token = this.token;
          data.app_id = this.app_id;
          data.open = this.ruleForm.open ? 1 : 0;
          data.required_form = this.requiredArr;
          data.optional_form = this.optionsArr;
          data.background_pic_url = this.background_pic_url;
          if (this.page_status) {
            this.opCard(data);
          } else {
            this.editCon(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 开卡
    opCard(data) {
      CreateMiniCard(data).then(res => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$router.push("miniCard");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改
    editCon(data) {
      let {card_id, logo_url, title, color, notice, description, service_phone, open } = data
      let mydata = {
        token: this.token,
        app_id: this.app_id,
        card_id: this.$route.query.id,
        logo_url, title, color, notice, description, service_phone, open
      }
      // 获取修改开卡字段
      this.getWxCon(this.$route.query.id, this.requiredArr, this.optionsArr);
      editWxCard(mydata).then(res => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$router.push("miniCard");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
<style lang="scss" scoped>
@import "../business/sub_com";
.bodycontent {
  display: flex;
  background: #ffffff;
  padding: 30px 27px 0;
  justify-content: flex-start;
}
.phone-con {
  min-width: 375px;
  height: 700px;
  padding: 0 10px;
  border: 1px solid #dfdfdf;
  background: #ffffff;
}
.card-con {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.card-set {
  flex: 1;
  max-width: 400px;
  margin-left: 20px;
}
.color-con {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  justify-content: flex-start;
}
.color-item {
  width: 30px;
  height: 30px;
  margin-left: 10px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  background: aquamarine;
}
</style>
